import { asText } from '~/components/Abstracts/Storyblok'

export function serializeSearchContent(content): string {
  let searchContent = ``
  const wysiwygText = content?.product_wysiwyg
    ?.map((wysiwyg) => {
      const rightText = asText(wysiwyg?.right_text) ?? null
      const leftText = asText(wysiwyg?.left_text) ?? null

      return rightText && leftText
        ? `${rightText}\n${leftText}`
        : `${rightText ?? ''}${leftText ?? ''}`
    })
    ?.join('\n')

  const accordionsText = content?.accordions
    ?.map((accordion) => asText(accordion.text))
    ?.join('\n')

  searchContent += content?.big_description
    ? `${content?.big_description}\n`
    : ``
  searchContent += content?.small_description
    ? `${content?.small_description}\n`
    : ``
  searchContent += asText(content?.product_big_paragraph)
    ? `${asText(content?.product_big_paragraph)}\n`
    : ``
  searchContent += wysiwygText ? `${wysiwygText}\n` : ``
  searchContent += accordionsText ? `${accordionsText}\n` : ``
  return searchContent
}
